import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from '../../../models/link';
import ImageHolder from '../../ImageHolder';

const IMAGE_TYPE = {
  big: "big",
  small: "small",
  none: "none"
};

class LinkFeedView extends Component {
  static propTypes = {
    link: PropTypes.instanceOf(Link).isRequired
  };

  get imageType() {
    const { link : { images } } = this.props;
    if (images.isEmpty()) {
      return IMAGE_TYPE.none;
    }

    const image = images.first();

    if (Number(image.get('width')) > 350 && Number(image.get('height')) > 140) {
      return IMAGE_TYPE.big;
    } else if (Number(image.get('width')) > 61 && Number(image.get('height')) > 61) {
      return IMAGE_TYPE.small;
    }
    return IMAGE_TYPE.none;
  }

  renderImage() {
    const { link : { images } } = this.props;

    if (this.imageType === IMAGE_TYPE.big) {
      return (
        <div className="wrap_thumb">
          <ImageHolder image={images.first()} />
        </div>
      );
    } else if (this.imageType === IMAGE_TYPE.small) {
      return (
        <div className="wrap_thumb">
          <ImageHolder image={images.first()} style={{ position: 'absolute', top: 0, left: 0, width: 150, height:150 }} />
        </div>
      );
    }
    return null;
  }

  render() {
    const { link } = this.props;

    const getCardStyle = () => {
      if (this.imageType === IMAGE_TYPE.small) {
        return 'card_scrab2';
      } else if (this.imageType === IMAGE_TYPE.none) {
        return 'card_scrab3';
      }
      return '';
    };

    return (
      <div className="post_card">
        <div className={`card_default card_scrab ${getCardStyle()}`}>
          <a href={link.requestedUrl} className="link_card" target="_blank">
            {this.renderImage()}
            <div className="info_cont">
              <strong className="tit_card">{link.title}</strong>
              {
                (link.description && link.description !== "") ? (
                    <p className="desc_card">{link.description}</p>
                  ) : null
              }
              <span className="txt_url">{link.host}</span>
            </div>
          </a>
        </div>
      </div>
    );
  }
}

export default LinkFeedView;



// WEBPACK FOOTER //
// ./src/components/PostBox/FeedView/LinkFeedView.js